var objectToString = require('../static/staticObjectToString')

function helperCreateInInObjectString (type) {
  return function (obj) {
    return '[object ' + type + ']' === objectToString.call(obj)
  }
}

module.exports = helperCreateInInObjectString



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/methods/base/helperCreateInInObjectString.js
// module id = 94cz
// module chunks = 0